import React from 'react';
import {observer} from 'mobx-react';
import {Input} from 'components';
import {FormattedMessage} from 'react-intl';

const HolidayNameInput = observer(({uiState}) => {
  const {currentHoliday, errors} = uiState;

  return (
    <div className="clearfix table py1">
      <div className="col-5 table-cell align-middle">
        <FormattedMessage id='time_off.holidays.Holiday Name'/>
      </div>
      <div className="col-7 table-cell">
        <Input
          type="text"
          name="name"
          placeholder="time_off.holidays.e.g., New Year's Day"
          className="full-width"
          errorMessage={errors.name}
          value={currentHoliday.name}
          onChange={e => currentHoliday.merge({name: e.target.value})}
        />
      </div>
    </div>
  );
});

export default HolidayNameInput;
